import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getHealthCheck = unaryRpc({
  name: "getHealthCheck",
  input: z.object({}),
  output: z.object({ status: z.string(), timestamp: z.string() }),
});
